import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReadMore } from '@routific/hive/v5';

interface Props {
  value: string;
}

const CollapsibleNote: React.FC<Props> = ({ value }) => {
  const { t } = useTranslation('common');

  return (
    <ReadMore
      lines={3}
      readMoreLabel={t('collapse.more')}
      showLessLabel={t('collapse.less')}
      data-testid="collapsible-field"
    >
      {value}
    </ReadMore>
  );
};

export default CollapsibleNote;
